import { render } from "./Education.vue?vue&type=template&id=198755b2&scoped=true&bindings={}"
import script from "./Education.vue?vue&type=script&lang=ts"
export * from "./Education.vue?vue&type=script&lang=ts"

import "./Education.vue?vue&type=style&index=0&id=198755b2&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-198755b2"

export default script